export function getJsonFromLocalStorage(key: string): any {
  return JSON.parse(localStorage.getItem(key) as string);
}

export function getStringFromLocalStorage(key: string): string {
  return localStorage.getItem(key) as string;
}

export function saveJsonToLocalStorage(key: string, data: {}): void {
  localStorage.setItem(key, JSON.stringify(data));
}
